export const API_GET_ALL_PROVIDER = "/proveedor/";
export const API_GET_SEARCH_PROVIDERS = "/proveedor/";
export const API_PUT_UPDATE_PROVIDERS = "/proveedor/actualizar";
export const API_POST_SAVE_PROVIDERS = "/proveedor/registrar";